
export const APP_NAME = "Let's Stop Covid";

export const REDIRECT_URL = {
	base: 'http://groftware.tech',
	ios: 'http://groftware.tech/iosapp',
	android: 'http://groftware.tech/androidapp',
}